module.exports = __webpack_public_path__ + "img/section21.9e69f9be.png";